<template>
  <footer class="footer fixed bottom-0 left-0 w-full z-50">
    <div class="flex h-full items-center justify-between pt-0 md:pt-1 pb-3">
      <div class="text-right ml-6">
        <div
          class="border-custom border-b-2 ml-auto border-t-2 w-20 md:w-24 rounded"
        ></div>
        <h2 class="text-gray-100 md:text-xl">
          <slot />
        </h2>
      </div>

      <div class="mr-4 md:mr-12 text-white">
        <a
          href="http://facebook.com/spyows"
          class="inline-block w-8 h-8 p-1 rounded-full mx-1 bg-gray-400 bg-opacity-50 hover:bg-opacity-25"
        >
          <box-icon
            name="facebook"
            type="logo"
            animation="tada-hover"
            color="#ffffff"
          ></box-icon>
        </a>
        <a
          href="http://twitter.com/spyows"
          class="inline-block w-8 h-8 p-1 rounded-full mx-1 bg-gray-400 bg-opacity-50 hover:bg-opacity-25"
        >
          <box-icon
            name="twitter"
            type="logo"
            animation="tada-hover"
            color="#ffffff"
          ></box-icon>
        </a>
        <a
          href="javascript:void(0)"
          class="inline-block w-8 h-8 p-1 rounded-full mx-1 bg-gray-400 bg-opacity-50 hover:bg-opacity-25"
        >
          <box-icon
            name="linkedin"
            type="logo"
            animation="tada-hover"
            color="#ffffff"
          ></box-icon>
        </a>
      </div>
      <!-- <div class="mb-5 md:mb-10 mr-12">
          <img class="w-12" src="/images/chat.svg" alt="Chat Icon" />
        </div> -->
    </div>
  </footer>
</template>

<script>
import "boxicons";
export default {
  name: "Footer"
};
</script>
